
































































import { Component, Prop, Vue } from "vue-property-decorator";
import _ from "lodash";
import CatalogCompensationRepository from "@/repositories/zero-waste/CatalogCompensationRepository";
import EventBus from "front-component/EventBus";
import Http from "front-component/Http";
import { Getter } from "vuex-class";

const components = {
};

@Component({components})
export default class ValidationCampaignForm extends Vue {
    public amountChanged: boolean = false;
    private loading: boolean = false;

    @Prop({type: Number, default: 0}) public globalBudget!: number | null;
    @Prop(Boolean) public visible!: boolean;
    @Prop(Boolean) public isAllCampaigns!: boolean;
    @Prop(Object) public filters!: object;
    @Prop() public campaignAvailable: any;
    @Prop() public campaignExpired: any;
    @Prop() public campaignValidated: any;
    @Prop(Number) public countCampaigns!: number;

    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    public validateCampaigns(): any {
        let updated = this.campaignAvailable.length;
        this.loading = true;

        if (this.isAllCampaigns === true) {
            const params = { filters: this.filters};
            Http.get(
                "/masscampaignsvalidation",
                params,
                () => {
                    this.loading = false;
                    EventBus.$emit("mass-catalog-status-updated");
                    this.$message({
                        message: _.invoke(this.$options.filters, "trans", "CampaignsValidationSuccess"),
                        type: "success"
                    });
                },
                "errorValidateCampaigns"
            );
        } else {
            return Promise.all(this.campaignAvailable.map((campaign: any) => {
                const catalogCompensation = {
                    uuid: campaign.uuid,
                    isValidated: true,
                };
                return CatalogCompensationRepository.save(catalogCompensation).then(() => {
                    updated--;
                    if (0 === updated) {
                        EventBus.$emit("mass-catalog-status-updated");
                        this.loading = false;
                    }
                });
            })).catch(() => {
                this.loading = false;
                return;
            });
        }
    }

    public get globalBudgetLocal(): string {
        const globalBudget = this.globalBudget ? this.globalBudget : 0;

        if (this.hasFeature("CONFIG_SOCLE")) {
            const countCampaigns = this.countCampaigns ? this.countCampaigns : 0;
            // TODO : 👇 Export calcul in Backend (cospirit-api)
            const total = globalBudget + (countCampaigns * (206.59 + 28.41));
            return _.invoke(this.$options.filters, "price", total);
        }

        return _.invoke(this.$options.filters, "price", this.globalBudget);
    }

    public goBack() {
        this.$emit("update:visible", false);
    }

    public closed() {
        this.$emit("closed");
    }
}

